import { BaseService } from './base.service';
import { ErrorWrapper, ResponseWrapper } from './util';

export class AdminsService extends BaseService {
  static async getAdmins () {
    try {
      const response = await this.request({ auth: true, v2: true }).get('/admin/user');
      
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async createNewAdmin (data) {
    try {
      const response = await this.request({ auth: true, v2: true }).post('/admin/user', data);
      
      return new ResponseWrapper(response, response.data.body);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async updateAdminDetails (adminid, data) {
    try {
      const response = await this.request({ auth: true }).put(
        `/admin/${adminid}`,
        data
      );
      
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async reportIssue (patientid, data) {
    try {
      const response = await this.request({ auth: true }).post(
        `/admin/patient/${patientid}/report`,
        data
      );
      
      return new ResponseWrapper(response, response.data.body);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async removeFromCampaign (patientid, selectedCampaign) {
    try {
      const response = await this.request({ auth: true }).delete(
        `/patient/${patientid}/campaign?action=${selectedCampaign}`
      );
      
      return new ResponseWrapper(response, response.data.body);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }
}
